import React, { useCallback, useEffect, useRef } from "react";
import Modal from "./modal";
import { Link } from "./link";
import { normalizeRelativePath } from "../utility/paths";
import BabelProdottoIntro from "./babel-prodotto-intro";
import safeSlufigy from "../utility/safe-slugify";
import ArrowRight from "../icons/arrow-right-black.svg";

const AccessoriesAndConsumablesModal = ({
  show,
  onHide,
  babelProdotto,
  energyClassImg,
  config,
  productTitle,
  lineProductName2,
  readMoreDescription,
  location,
  labelManagerLabels,
  siteMetadata,
  liferayProductNotes,
  contributoRaee,
  extraServices,
  priceData,
  compareProducts,
  storeLink,
  onClickWtb,
  compatibleLinesTitle,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (show && ref.current) {
      ref.current.focus();
    }
  }, [show]);

  const closeDialog = useCallback(() => {
    if (ref.current) {
      onHide();
    }
  }, [onHide]);

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") {
        closeDialog();
      }
    },
    [closeDialog]
  );

  const linkProductPage = normalizeRelativePath(
    `/${[
      babelProdotto.pageLine.slug.startsWith("/")
        ? babelProdotto.pageLine.slug.substring(1)
        : babelProdotto.pageLine.slug,
      babelProdotto.key_prod,
      babelProdotto.productName.toLowerCase(),
    ]
      .map(safeSlufigy)
      .join("/")}/`
  );

  return (
    <Modal>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <div
        ref={ref}
        className={`accessories-and-consumables-modal${
          show ? " accessories-and-consumables-modal--show" : ""
        }`}
        role="dialog"
        aria-hidden={!show}
        onKeyDown={onKeyDown}
      >
        <div className="accessories-and-consumables-modal__dialog" role="document">
          <div className="accessories-and-consumables-modal__alert ">
            <div className="accessories-and-consumables-modal__alert-content text-left">
              <div className="d-flex pb-3 pt-3 accessories-and-consumables-modal__top-bar">
                <button
                  className="pl-4 accessories-and-consumables-modal__top-bar-close"
                  onClick={closeDialog}
                >
                  {labelManagerLabels.close}
                </button>
                <div className="pl-4 accessories-and-consumables-modal__top-bar-title">
                  {labelManagerLabels.productPreview}
                </div>
              </div>

              <BabelProdottoIntro
                babelProdotto={babelProdotto}
                energyClassImg={energyClassImg}
                config={config}
                productTitle={productTitle}
                lineProductName2={lineProductName2}
                readMoreDescription={readMoreDescription}
                location={location}
                labelManagerLabels={labelManagerLabels}
                siteMetadata={siteMetadata}
                liferayProductNotes={liferayProductNotes}
                contributoRaee={contributoRaee}
                extraServices={extraServices}
                priceData={priceData}
                compareProducts={compareProducts}
                origin="AcModal"
                linkProductPage={linkProductPage}
                storeLink={storeLink}
                onClickWtb={onClickWtb}
                compatibleLinesTitle={compatibleLinesTitle}
              />

              <div className="d-flex flex-column flex-md-row justify-content-center align-items-center mt-2">
                <Link
                  to={linkProductPage}
                  className="accessories-and-consumables-modal__product-link"
                >
                  {labelManagerLabels.goToProductPage}
                  <ArrowRight />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AccessoriesAndConsumablesModal;
